import filter from "@/api/filter";

// 上游对账
export const upstream = [
  {
    title: "保单号",
    align: "center",
    fixed: "left",
    key: "policyNo",
    minWidth: 200,
    tooltip: true,
  },
  {
    title: "批单号",
    align: "center",
    key: "billNo",
    fixed: "left",
    minWidth: 200,
    tooltip: true,
  },
  {
    title: "所属对账单",
    align: "center",
    slot: "checkName",
    minWidth: 200,
    tooltip: true,
  },
  {
    title: "上游结算状态",
    align: "center",
    key: "settlementStatus",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "对账状态",
    align: "center",
    slot: "reconciliationStatusDesc",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "对账日期",
    align: "center",
    key: "checkDate",
    minWidth: 140,
    tooltip: true,
    render(h, params) {
      if(params.row.checkDate){
        const value = filter.filterTime(params.row.checkDate, "YYYY-MM-DD");
        return <span>{value}</span>;
      }
    },
  },
  {
    title: "供应商",
    align: "center",
    key: "supplier",
    minWidth: 160,
    tooltip: true,
  },
  {
    title: "保险公司",
    align: "center",
    key: "companyName",
    minWidth: 160,
    tooltip: true,
  },
  {
    title: "保险产品",
    align: "center",
    key: "productName",
    minWidth: 260,
    tooltip: true,
  },
  {
    title: "险种名称",
    align: "center",
    key: "productTypeName",
    minWidth: 260,
    tooltip: true,
  },
  {
    title: "最新状态",
    align: "center",
    key: "policyStatus",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "承保日期",
    align: "center",
    key: "insureTime",
    minWidth: 120,
    tooltip: true,
    render(h, params) {
      if(params.row.insureTime){
        const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
        return <span>{value}</span>;
      }
    },
  },
  {
    title: "生效日期",
    align: "center",
    key: "effectTime",
    minWidth: 120,
    tooltip: true,
    render(h, params) {
      if(params.row.effectTime){
        const value = filter.filterTime(params.row.effectTime, "YYYY-MM-DD");
        return <span>{value}</span>;
      }
    },
  },
  {
    title: "保费",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      if(params.row.reviseFee){
        return <span>{params.row.fee}（已强平）</span>

      }else{
        return <span>{params.row.fee}</span>;
      }
    },
  },
  {
    title: "上游结算保费",
    align: "center",
    key: "supplierFee",
    minWidth: 100,
  },
  {
    title: "费率",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      if(params.row.reviseCommission){
        return <span>{params.row.commission}（已强平）</span>

      }else{
        return <span>{params.row.commission}</span>;
      }
    },
  },
  {
    title: "上游结算费率",
    align: "center",
    key: "supplierCommission",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "费用",
    align: "center",
    key: "commissionPrice",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      if(params.row.reviseCommissionPrice){
        return <Tooltip
          trigger="hover"
          content="content"
          transfer={true}
        >
          <span>{params.row.commissionPrice}</span>
          <span class="tip-icon">?</span>
          <div slot="content">
            <span>{'(强平：'+params.row.reviseCommissionPrice+')'}</span>
          </div>
        </Tooltip>
      }else{
        return <span>{params.row.commissionPrice}</span>;
      }
    },
  },
  {
    title: "上游结算费用",
    align: "center",
    key: "supplierCommissionPrice",
    minWidth: 100,
    tooltip: true,
  },
  {
    title: "投保人",
    align: "center",
    key: "holderName",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "出单业务员",
    align: "center",
    key: "salesmanName",
    minWidth: 120,
    tooltip: true,
  },
  {
    title: "出单团队",
    align: "center",
    minWidth: 220,
    render(h, params) {
      if (!params.row.groupName) {
        return h("div", {}, "-");
      } else {
        return h("div", {}, params.row.groupName);
      }
    },
  },
  {
    title: "出单机构",
    align: "center",
    key: "orgName",
    minWidth: 200,
  },
  {
    title: "已回款？",
    key: "receivableStatus",
    width: 100,
    align: "center",
  },
  {
    title: "已付款？",
    key: "payStatus",
    width: 100,
    align: "center",
  },
  {
    title: "核收人",
    align: "center",
    key: "reviewer",
    minWidth: 120,
    tooltip: true,
  },
]
